import React from 'react';
import TextField from '../Main/TextField';
import style from './Configurator.module.css';

const HexToRGB = (hex) => {
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	if (!result) return null;
	return {
		r: parseInt(result[1], 16),
		g: parseInt(result[2], 16),
		b: parseInt(result[3], 16)
	};
}

function ComponentToHex(value) {
	return Math.max(0, Math.min(255, value))
		.toString(16)
		.padStart(2, "0");
}

const RGBToHex = (r, g, b) => {
	return "#" + ComponentToHex(r) + ComponentToHex(g) + ComponentToHex(b);
}

const RGBColorInput = (props) => {

	const onAllChange = (event) => {
		if (!event?.target?.value) return;
		const rgbValues = HexToRGB(event.target.value);
		props.onRChange({target: { value: rgbValues.r}});
		props.onGChange({target: { value: rgbValues.g}});
		props.onBChange({target: { value: rgbValues.b}});
	};

	return (
		<div className={style.InputWrapperOuterStyle}>
			<div className={style.InputWrapperHeaderStyle}>
				<div className={style.Header}>{props.label}</div>
				<input className={style.ColorChecker}
					   type={'color'}
					   onChange={onAllChange}
					   value={RGBToHex(props.RValue, props.GValue, props.BValue)}
					   style={{['backgroundColor']: 'rgb(' + props.RValue + ',' + props.GValue + ',' + props.BValue + ')'}}/>
			</div>
			<div className={style.InputWrapperInnerStyle}>
				<TextField
					WrapperStyle={style.InputStyle}
					onChange={props.onRChange}
					value={props.RValue}
					placeholder={'Red'}
					label={'R (0-255)'}
				/>
				<TextField
					WrapperStyle={style.InputStyle}
					onChange={props.onGChange}
					value={props.GValue}
					placeholder={'Green'}
					label={'G (0-255)'}
				/>
				<TextField
					WrapperStyle={style.InputStyle}
					onChange={props.onBChange}
					value={props.BValue}
					placeholder={'Blue'}
					label={'B (0-255)'}
				/>
			</div>
		</div>
	);
};

export default RGBColorInput;